import {
  Show,
  TabbedShowLayout,
  TextField,
  useShowContext,
  useTranslate,
} from "react-admin";
import { useState } from "react";
import { ColorField } from "react-admin-color-picker";
import {
  DateField,
  Title,
  ShowOnlyTopToolbar,
} from "../../shared/components/index.js";
import Iframe from "react-iframe";

const PagePreview = () => {
  const t = useTranslate();
  const {
    record: { id: pageId },
  } = useShowContext();

  const [click, setClick] = useState(false);

  const handleClick = () => {
    setClick(true);
  };

  return (
    <>
      {click === true && (
        <div className="block-preview-container">
          <Iframe
            url={`/admin/Block?displayedFilters=%7B%7D&filter=%7B%22page_id%22%3A%22${pageId}%22%7D`}
            width="1170px"
            height="700px"
            id=""
            className=""
            display="flex"
            position="relative"
            scrolling="none"
            styles={{ border: "none", borderBottom: "1px solid grey" }}
          />
        </div>
      )}
      <div className="page-preview-container">
        <Iframe
          url={`/preview/${pageId}`}
          width="400px"
          height="640px"
          id=""
          className=""
          display="flex"
          position="relative"
        />
        <div
          style={{
            flexDirection: "row",
          }}
        >
          {click === false ? (
            <button className="block-edit-button" onClick={handleClick}>
              {t("buttons.edit")}
            </button>
          ) : (
            <button
              className="block-edit-button"
              onClick={() => setClick(false)}
            >
              {t("buttons.close_editing")}
            </button>
          )}
        </div>
      </div>
    </>
  );
};

const showPage = () => {
  return (
    <Show title={<Title source="name" />} actions={<ShowOnlyTopToolbar />}>
      <TabbedShowLayout>
        <TabbedShowLayout.Tab label="resources.Page.source.tab.basic">
          <TextField source="name" />
          <ColorField source="styles.backgroundColor" />
          <ColorField source="styles.color" />
          <DateField source="created_at" />
          <DateField source="updated_at" />
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="resources.Page.source.tab.preview">
          <div className="p_container">
            <PagePreview />
          </div>
        </TabbedShowLayout.Tab>
      </TabbedShowLayout>
    </Show>
  );
};

export default showPage;
